module.exports = __webpack_public_path__ + "static/media/morning_profile_background.9786ee02.jpg";